enum EStoreStateKeys {
  user = 'user',
  settings = 'settings',
  agent = 'agent',
  chatbot = 'chatbot',
  conversation = 'conversation',
  organization = 'organization',
  UIElements = 'UIElements',
  portalAlerts = 'portalAlerts',
  adminPortal = 'adminPortal',
}

export default EStoreStateKeys
